import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { CartModelServer } from "../../models/cart.model";
import { CartService } from "../../services/cart.service";
import { Router } from "@angular/router";
import { OrderService } from "../../services/order.service";
import { ModalService } from '../../services/modal.service';
import { MainService } from '../../services/main.service';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit {
  

  cartData: CartModelServer;
  cartTotal: Number;
  showSpinner: Boolean;
  checkoutForm!: FormGroup;

  constructor(private cartService: CartService,
              private orderService: OrderService,
              private router: Router,
              private  spinner: NgxSpinnerService,
              private MainService: MainService,
              public ModalService:ModalService,
               private fb: FormBuilder
              //private fb: FormBuilder
  )
  {
    /*this.checkoutForm = this.fb.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required]],

    });*/
  }

  ngOnInit(): void {
    this.cartService.cartDataObs$.subscribe(data => this.cartData = data);
    this.cartService.cartTotal$.subscribe(total => this.cartTotal = total);

      this.checkoutForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      // password: ['', [Validators.required, Validators.minLength(6)]],
      fname: [''],
      lname: [''],
      username: [''],
      address: [''],
      city: [''],
      country: [''],
      tel: ['']
    });

  }

  onCheckout() {
  if (!this.MainService.isLoggedIn()) {
    this.ModalService.openLoginModal();
    return;
  }

  //  if (this.checkoutForm.invalid) {
  //   this.checkoutForm.markAllAsTouched(); // show errors
  //   return;
  // }
 

  const user = this.MainService.getCurrentUser(); // assume it gives { id: number, name: string }
  const orderProducts = this.cartData.data.map((item: any) => {
    return {
      id: item.product.id,
      incart: item.numInCart  // must match backend order.js
    };
  });

  const orderData = {
    userId: user.id,
    products: orderProducts,
    billing: this.checkoutForm.value 
  };

// this.spinner.show();
  this.orderService.placeNewOrder(orderData).subscribe({
    next: (res) => {
      this.spinner.hide();
      if (res.success) {
        alert(`✅ Order placed successfully with ID: ${res.order_id}`);
        this.cartService.clearCart();  // implement clearCart in CartService
        this.router.navigate(['/']);   // redirect to homepage or thank you page
      } else {
        alert('❌ Failed to place order. Try again later.');
      }
    },
    error: (err) => {
      this.spinner.hide();
      console.error('Order error:', err);
      alert('❌ Server error while placing order');
    }
  });
}

 
}